import React from "react";
import { Row, Col, Form, Button } from "react-bootstrap";
import Card from "../../../src/components/Card.js";
import ModalUPT from "./modal/ModalUPT.js";
import topImage from "../../assets/images/dashboard/top-image.jpg";

import { useRegister } from "./hooks/useRegister.js";
import TraderForm from "./components/TraderForm.js";
import UserForm from "./components/UserForm.js";
import AlertManager from "./components/AlertManager.js";
import UserAgreement from "./components/UserAgreement.js";

const Register = () => {
    const {
        trader, setTrader,
        user, setUser,
        trade, tradeFound,
        propinsi, kota,
        kodeUPT, setKodeUPT,
        namaUPT, setNamaUPT,
        services, setServices,
        files, setFiles,
        captcha, textCaptcha, setTextCaptcha,
        showUPT, setShowUPT,
        alerts, setAlert,
        isSubmitting,
        agreementChecked, setAgreementChecked,
        saveTrader,
        handleNPWPBlur,
        handlePropinsiChange,
        refreshCaptcha,
        navigate,
    } = useRegister();

    return (
        <>
            <div className="header">
                <section className="register-content">
                    <Row className="m-0 align-items-center bg-white vh-100">
                        <Col
                            md="12"
                            style={{
                                background: `url(${topImage})`,
                                backgroundSize: "cover",
                                backgroundRepeat: "no-repeat",
                                height: "100vh",
                                position: "relative",
                            }}
                        >
                            <Row className="justify-content-center">
                                <Col md="10">
                                    <Card className="card-transparent shadow-sm d-flex justify-content-center mb-0 auth-card mt-5 mb-5 border">
                                        <Card.Body>
                                            <h2 className="mb-3 mt-4 fw-bold text-primary">
                                                Form Registrasi
                                            </h2>
                                            <ul>
                                                <li>Harap isi data dengan benar sesuai dengan dokumen atau berkas resmi yang Anda miliki.</li>
                                                <li>Data dengan tanda bintang (*) harus diisi.</li>
                                                <li>Jenis file yang bisa diupload .pdf, .png, .jpg atau .jpeg dan ukuran Maks. file 1 Mb</li>
                                            </ul>

                                            <Form onSubmit={saveTrader}>
                                                <h4 className="mb-4 mt-5">Data Umum Pengguna Jasa</h4>

                                                <TraderForm
                                                    trader={trader}
                                                    setTrader={setTrader}
                                                    trade={trade}
                                                    tradeFound={tradeFound}
                                                    propinsi={propinsi}
                                                    kota={kota}
                                                    files={files}
                                                    setFiles={setFiles}
                                                    handleNPWPBlur={handleNPWPBlur}
                                                    handlePropinsiChange={handlePropinsiChange}
                                                />

                                                <h4 className="mb-4 mt-5">Data Pengguna Jasa</h4>

                                                <UserForm
                                                    user={user}
                                                    setUser={setUser}
                                                    trade={trade}
                                                    tradeFound={tradeFound}
                                                    files={files}
                                                    setFiles={setFiles}
                                                    namaUPT={namaUPT}
                                                    captcha={captcha}
                                                    setTextCaptcha={setTextCaptcha}
                                                    services={services}
                                                    setServices={setServices}
                                                    onClickUPT={() => setShowUPT(true)}
                                                    refreshCaptcha={refreshCaptcha}
                                                />

                                                <UserAgreement
                                                    checked={agreementChecked}
                                                    onChange={(e) => setAgreementChecked(e.target.checked)}
                                                />

                                                <div className="text-center mt-5">
                                                    <Button
                                                        type="submit"
                                                        variant="primary"
                                                        disabled={tradeFound || isSubmitting || !agreementChecked}
                                                        className="me-2"
                                                    >
                                                        {isSubmitting ? "Memproses..." : "Submit"}
                                                    </Button>
                                                    <Button
                                                        type="button"
                                                        variant="danger"
                                                        onClick={() => navigate("/")}
                                                    >
                                                        Cancel
                                                    </Button>
                                                </div>
                                            </Form>
                                        </Card.Body>
                                    </Card>
                                </Col>
                            </Row>
                        </Col>
                    </Row>

                    <ModalUPT
                        setKodeUPT={setKodeUPT}
                        setNamaUPT={setNamaUPT}
                        showUPT={showUPT}
                        handleCloseUPT={() => setShowUPT(false)}
                    />
                </section>
            </div>

            <AlertManager
                alerts={alerts}
                setAlert={setAlert}
                onSelesai={() => { setAlert("selesai", false); navigate("/"); }}
                onTradeFound={() => { setAlert("tradeFound", false); navigate("/"); }}
                // onTradeFound={() => { setAlert("tradeFound", false);}}
            />
        </>
    );
};

export default Register;